import React, { useState } from 'react';
import type { EstadiaCliente } from '../../../models';
import {
  STATUS_ESTADIA_CLIENTE_LABELS,
  STATUS_ESTADIA_CLIENTE_BADGE_CLASS,
  PROCESSO_MOVIMENTACAO_LABELS,
} from '../equipamentosListPage.definitions';
import EditarEstadiaModal from './EditarEstadiaModal';
import { normalizarPatrimonio } from '../../../models/equipamento.utils';

interface EstadiaKanbanCardProps {
  estadia: EstadiaCliente;
  patrimonio: string | null;
  modelo: string | null;
  nomeCliente: string | null;
  nomeColaboradorCotado: string | null;
  /** Por Status, a coluna já diz o status — o badge só repetiria; Por Cliente, vale mostrar. */
  mostrarStatus: boolean;
  /** Por Cliente, a coluna já diz o cliente. */
  mostrarCliente: boolean;
}

/** Versão compacta do EstadiaClienteCard pro Kanban — clicar abre a mesma edição completa
 * (EditarEstadiaModal). As ações de transição (confirmar chegada, recolher etc.) ficam só
 * na Lista por enquanto (Kanban sem arrastar, decisão do usuário). */
export default function EstadiaKanbanCard({
  estadia,
  patrimonio,
  modelo,
  nomeCliente,
  nomeColaboradorCotado,
  mostrarStatus,
  mostrarCliente,
}: EstadiaKanbanCardProps) {
  const [editarAberto, setEditarAberto] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setEditarAberto(true)}
        className="w-full rounded-md border border-gray-200 bg-white p-3 text-left text-sm hover:border-indigo-300"
      >
        <p className="font-montserrat font-bold text-gray-900">{normalizarPatrimonio(patrimonio) ?? 'Sem patrimônio'}</p>
        {modelo && <p className="truncate text-xs text-gray-600" title={modelo}>{modelo}</p>}
        {mostrarCliente && <p className="mt-1 truncate text-xs text-gray-500">{nomeCliente ?? '—'}</p>}
        <p className="mt-1 text-xs text-gray-500">{PROCESSO_MOVIMENTACAO_LABELS[estadia.motivo]}</p>
        {estadia.status !== 'encerrada' && nomeColaboradorCotado && (
          <p className="truncate text-xs text-gray-500">Cotado: {nomeColaboradorCotado}</p>
        )}
        {mostrarStatus && (
          <span
            className={`mt-2 inline-block rounded-full px-2 py-0.5 text-xs font-semibold ${STATUS_ESTADIA_CLIENTE_BADGE_CLASS[estadia.status]}`}
          >
            {STATUS_ESTADIA_CLIENTE_LABELS[estadia.status]}
          </span>
        )}
      </button>
      <EditarEstadiaModal isOpen={editarAberto} onClose={() => setEditarAberto(false)} estadia={estadia} />
    </>
  );
}
